/**
 * Created by Alan Yang on 3/08/2019. Happy Women's Day
 * Description:
 * FlatFileActions Component
 *
 * ------ maintenance history ------
 */

import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { AppConfig } from '../../tamalelibs/models/app-config.model';
import { ContextMenuConfig } from '../../widgets/tam-context-menu/tam-context-menu.model';
import { NotificationStyles } from '../../widgets/notification/notification.model';
import { ToastService } from '../../widgets/toast/toast.service';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { AlertButton, AlertBtnTypes } from '../../widgets/alert-window/alert-window.model';
import { CopyService } from '../../services/copy.service';

@Component({
    selector: 'tam-flat-file-actions',
    template: `<div class="flat-file-actions" kendoTooltip position="bottom"><smart-icon #anchor name="info-o" (click)="onInfoIconClicked()" class="light" title="Tips"></smart-icon></div>`,
    styles: [`.flat-file-actions{color:#007aff;font-size: 18px;display: flex;}`]
})
export class FlatFileActionsComponent implements ICellRendererAngularComp, OnInit {
    item: any;
    menuConfig: ContextMenuConfig;
    isPPCUser = false;

    private _copyURLDialogWidth = 650;

    constructor(
        private _alertWindow: AlertWindowService,
        private _copyService: CopyService,
        private _toast: ToastService) { }

    agInit(params: any): void {
        this.item = params.data;
    }

    ngOnInit() {
    }

    onInfoIconClicked(): void {
        const cancelButton = new AlertButton();
        cancelButton.text = 'Cancel';
        cancelButton.type = AlertBtnTypes.tertiary;
        cancelButton.visible = true;

        const copyButton = new AlertButton();
        copyButton.text = 'Copy the URL';
        copyButton.type = AlertBtnTypes.primary;
        copyButton.visible = true;

        const urlSring = location.protocol + '//' + location.host + AppConfig.dataproviderEndPoint + this.item.id;

        const subscription = this._alertWindow.custom(
            'Tips: How to upload new file to existing config through RestAPI?',
            ['URL: ' + urlSring,
                'Method: Put',
                'Parameter: Attachment'],
            cancelButton,
            copyButton,
            this._copyURLDialogWidth
        ).subscribe((result: boolean) => {
            if (result) {
                this._copyService.copy(urlSring);
                this._toast.notify({
                    message: 'RestAPI URL copied to clipboard.',
                    style: NotificationStyles.Success
                });
            }
            subscription.unsubscribe();
        });
    }

    refresh(): boolean {
        return true;
    }
}
